import { ThomasEvent } from "./ThomasEvents";
import { ThomasEventTypes } from "./ThomasEventTypes";

class ThomasRouteChangeEvent extends ThomasEvent {
  public static getRouteChangeEventDetails(url: string): {
    [key: string]: string;
  } {
    const HIERARCHY_PREFIX = `hierarchy_`;
    const HIERARCHY_MAX_PARTS = 6;

    const urlParts = url.split("/").filter(p => p);
    const result: { [key: string]: string } = {
      route: url,
    };

    for (let i = 1; i <= HIERARCHY_MAX_PARTS; i += 1) {
      result[`${HIERARCHY_PREFIX}${i}`] = urlParts[i - 1] ?? "";
    }

    return result;
  }

  constructor(url) {
    super(
      ThomasEventTypes.ACTION_TYPE_VIEW,
      ThomasRouteChangeEvent.getRouteChangeEventDetails(url),
      {
        component_type: ThomasEventTypes.COMPONENT_TYPE_PAGE,
      }
    );
  }
}

export { ThomasRouteChangeEvent };
